import {AxiosResponse} from 'axios';

import axios from '@/core/tools/axios';

import { MultipleBooking } from '../interfaces';


export default class MultipleBookingService {
  static createMultipleBooking(multipleBooking: MultipleBooking): Promise<AxiosResponse> {
    return axios.post('/bookings/', multipleBooking);
  }

  static getNotBookableDates(customerId: string, slotStartTime: string, seatsReq: number): Promise<AxiosResponse> {
    return axios.get(`/bookings/check/${customerId}/${slotStartTime}/${seatsReq}/`);
  }
}
